/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_preset_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Press Start to begin the countdown and Pause to hold it. Reset returns it to the full time. The timer stays accurate even if you switch tabs, and an alarm plays when it finishes.`)
};

const es_timer_preset_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presiona Iniciar para comenzar la cuenta regresiva y Pausar para detenerla. Reiniciar la devuelve al tiempo completo. El temporizador se mantiene preciso aunque cambies de pestaña, y suena una alarma cuando termina.`)
};

const de_timer_preset_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drücke Start, um den Countdown zu beginnen, und Pause, um ihn anzuhalten. Zurücksetzen bringt ihn zurück auf die volle Zeit. Der Timer bleibt genau, auch wenn du den Tab wechselst, und beim Ablauf ertönt ein Alarm.`)
};

const nl_timer_preset_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Druk op Start om de aftelling te beginnen en op Pauze om deze te onderbreken. Reset zet de timer terug op de volledige tijd. De timer blijft nauwkeurig, ook als je van tabblad wisselt, en er klinkt een alarm als hij klaar is.`)
};

const fr_timer_preset_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appuyez sur Démarrer pour lancer le compte à rebours et sur Pause pour l’interrompre. Réinitialiser le ramène à la durée complète. Le minuteur reste précis même si vous changez d’onglet, et une alarme retentit à la fin.`)
};

const it_timer_preset_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premi Avvia per iniziare il countdown e Pausa per sospenderlo. Ripristina lo riporta al tempo completo. Il timer resta preciso anche se cambi scheda, e un allarme suona al termine.`)
};

const pt_br2_timer_preset_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pressione Iniciar para começar a contagem regressiva e Pausar para interrompê-la temporariamente. Redefinir volta ao tempo total. O temporizador mantém a precisão mesmo se você trocar de aba, e um alarme toca quando termina.`)
};

const pt_timer_preset_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prima Iniciar para começar a contagem decrescente e Pausar para a suspender. Repor devolve-a à duração total. O temporizador mantém-se exato mesmo que mude de separador, e um alarme toca quando termina.`)
};

const ja_timer_preset_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタートを押すとカウントダウンが始まり、一時停止で止められます。リセットで最初の時間に戻ります。タブを切り替えても正確に動作し、終了時にはアラームが鳴ります。`)
};

const zh_timer_preset_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击开始启动倒计时，点击暂停可以暂停计时。重置会恢复到完整时长。即使切换标签页，计时器也能保持准确，结束时会播放闹铃。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_preset_howto = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_preset_howto(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_preset_howto", locale)
	if (locale === "en") return en_timer_preset_howto(inputs)
	if (locale === "es") return es_timer_preset_howto(inputs)
	if (locale === "de") return de_timer_preset_howto(inputs)
	if (locale === "nl") return nl_timer_preset_howto(inputs)
	if (locale === "fr") return fr_timer_preset_howto(inputs)
	if (locale === "it") return it_timer_preset_howto(inputs)
	if (locale === "pt-BR") return pt_br2_timer_preset_howto(inputs)
	if (locale === "pt") return pt_timer_preset_howto(inputs)
	if (locale === "ja") return ja_timer_preset_howto(inputs)
	return zh_timer_preset_howto(inputs)
};